import { Icon } from '@iconify/react'
import { useStorefrontContent } from '@/branding/BrandingProvider'

export function EdgeAdvantageSection() {
  const { edge } = useStorefrontContent()

  return (
    <section id="edge" className="py-24 bg-navy text-white overflow-hidden relative">
      {/* Background grid pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 reveal-base">
          <h2 className="text-3xl font-medium tracking-tight mb-4">{edge.title}</h2>
          <p className="text-white/70 max-w-2xl mx-auto font-light">{edge.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Traditional */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-8 lg:p-10 rounded-[2rem] reveal-base delay-100">
            <h3 className="text-xl font-medium tracking-tight text-white/50 mb-6 flex items-center gap-3">
              <Icon icon={edge.traditional.icon} className="text-2xl" />
              {edge.traditional.title}
            </h3>
            <ul className="space-y-5">
              {edge.traditional.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/70 font-light">
                  <Icon icon="solar:close-circle-linear" className="text-red-400 mt-0.5 text-lg shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Zenzers */}
          <div className="bg-gradient-to-br from-rust/20 to-transparent border border-rust/30 p-8 lg:p-10 rounded-[2rem] relative reveal-base delay-200 shadow-2xl shadow-rust/5">
            <div className="absolute -top-4 -right-4 bg-rust text-white text-xs font-medium px-4 py-1.5 rounded-full shadow-lg">
              {edge.zenzers.badge}
            </div>
            <h3 className="text-xl font-medium tracking-tight text-white mb-6 flex items-center gap-3">
              <Icon icon={edge.zenzers.icon} className="text-2xl text-rust" />
              {edge.zenzers.title}
            </h3>
            <ul className="space-y-5">
              {edge.zenzers.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-white font-light">
                  <Icon icon="solar:check-circle-linear" className="text-rust mt-0.5 text-lg shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
